import {useEffect, useContext} from "react";
import {useNavigate, useParams} from "react-router-dom";
import AppConfigContext from "../context/AppConfigContext";
import { getStateFromSubdomain } from "../utils/utils";
import APP_ENV from "../config/appEnv";

const UTMPage = () => {
    const { source } = useParams();
    const navigate = useNavigate();
    const {config} = useContext(AppConfigContext);
    const state = getStateFromSubdomain();

    useEffect(() => {
        if (!config.tracking) {
            navigate("/");
            return;
        }

        if (source in config.tracking) {
            let utmQueryString = config.tracking[source];
            const separator = utmQueryString.includes("?") ? "&" : "?";
            if (state) {
                utmQueryString = utmQueryString + separator + "utm_state=" + state + "&utm_tenant=" + APP_ENV.CLIENT_SHORT_NAME.toLowerCase();
            } else {
                utmQueryString = utmQueryString + separator + "utm_tenant=" + APP_ENV.CLIENT_SHORT_NAME.toLowerCase();
            }

            navigate(utmQueryString);
            // refresh the page to trigger App.js utm tracking
            window.location.reload();
        }
    }, [config.tracking, navigate, state, source]);

    return (
        <div />
    )
}

export default UTMPage;
